export enum RouteLocationType {
  ORIGIN = 'ORIGIN',
  DESTINATION = 'DESTINATION',
}
